import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

export default function Menu({ userInfo }) {
  return (
    <>
      <Navbar bg="dark" variant="dark">
        <Container>
          <Nav className="me-auto">
            <Nav.Link href="/manager/">ホーム</Nav.Link>
            {userInfo.is_superuser ? (
              <>
                <Nav.Link href="/manager/clients/new">クライアント作成</Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link href="/manager/self/info">クライアント情報</Nav.Link>
              </>
            )}
          </Nav>
          <Navbar.Collapse className="justify-content-end">
            <Nav className="">
              <Nav.Link href="https://accuriodx.konicaminolta.com/qrreactappmanual" target="_blank">
                マニュアルはこちら
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
